// Components
import Svg from '../Components/shared/Svg'

export interface OutlineWrenchSvgProps {
  className?: string
}

export const OutlineWrenchSvg = ({ className }: OutlineWrenchSvgProps) => (
  <Svg
    className={className}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.4762 6H15.9365C15.4921 8.38095 13.3968 10.127 10.9682 10.127C10.6667 10.127 10.3651 10.0952 10.0635 10.0317L4.09523 16H2.1746L0.0317383 13.8571V11.9365L5.99999 5.96825C5.9365 5.66667 5.90475 5.36508 5.90475 5.06349C5.90475 2.26984 8.19047 0 10.9682 0C13.4603 0 15.5873 1.8254 15.9682 4.28571H11.4762L10.9841 5.14286L11.4762 6ZM10.9682 8.98413C12.3175 8.98413 13.5714 8.28571 14.2857 7.14286H10.8095L9.65079 5.14286L10.8095 3.14286H14.3809C13.6984 1.92064 12.3809 1.14286 10.9682 1.14286C8.80952 1.14286 7.04761 2.90476 7.04761 5.06349C7.04761 5.49206 7.12698 5.92064 7.26983 6.31746L1.1746 12.4127V13.381L2.65079 14.8571H3.61904L9.71428 8.76191C10.1111 8.90476 10.5397 8.98413 10.9682 8.98413Z'
      fill='currentColor'
    />
  </Svg>
)
